/**
 * 抬杠 
 */

/***
 * 1. 每帧都要更新；
 * 2. 缓存5帧
 */
import * as THREE from 'three'

import { disposeO3D } from '../js/threejsHelper';
import TS_AUXILIARY from '@/assets/images/trafficsign/TS_AUXILIARY.jpg'
import TS_CONSTRUCTION_SAFETY from '@/assets/images/trafficsign/TS_CONSTRUCTION_SAFETY.jpg'
import TS_DIRECTIVE from '@/assets/images/trafficsign/TS_DIRECTIVE.png'
import TS_HIGHWAY_GUIDE from '@/assets/images/trafficsign/TS_HIGHWAY_GUIDE.jpg'
import TS_PROHIBITION from '@/assets/images/trafficsign/TS_PROHIBITION.png'
import TS_TOURIST_AREA from '@/assets/images/trafficsign/TS_TOURIST_AREA.jpg'
import TS_UNKNOWN from '@/assets/images/trafficsign/TS_UNKNOWN.jpg'
import TS_WARNING from '@/assets/images/trafficsign/TS_WARNING.png'
import TS_WAY_GUIDE from '@/assets/images/trafficsign/TS_WAY_GUIDE.jpg'
import TS_PROHIBITION_STOP from '@/assets/images/trafficsign/TS_PROHIBITION_STOP.jpg'
import TS_PROHIBITION_YIELD from '@/assets/images/trafficsign/TS_PROHIBITION_YIELD.jpg'
import TS_PROHIBITION_NO_ENTER from '@/assets/images/trafficsign/TS_PROHIBITION_NO_ENTER.jpg'
import TS_PROHIBITION_NO_STOP from '@/assets/images/trafficsign/TS_PROHIBITION_NO_STOP.jpg'
import TS_PROHIBITION_SPEED_LIMIT from '@/assets/images/trafficsign/TS_PROHIBITION_SPEED_LIMIT.jpg'
import TS_PROHIBITION_HEIGHT_LIMIT from '@/assets/images/trafficsign/TS_PROHIBITION_HEIGHT_LIMIT.jpg'
import TS_PROHIBITION_WIDTH_LIMIT from '@/assets/images/trafficsign/TS_PROHIBITION_WIDTH_LIMIT.jpg'
import TS_PROHIBITION_WEIGHT_LIMIT from '@/assets/images/trafficsign/TS_PROHIBITION_WEIGHT_LIMIT.jpg'
import TS_PROHIBITION_AXLE_WEIGHT_LIMIT from '@/assets/images/trafficsign/TS_PROHIBITION_AXLE_WEIGHT_LIMIT.jpg'
/**
 * 显示隐藏标识；
 */
let show_channel = localStorage.getItem('topicChannelChecks')?.includes('/trackList/fused_track/traffic_sign');
/**
 * 模型缓存5帧之后，清除
 */
let model_clear_flag = 5;
/**
 * 存放模型的map
 */
let model_map = new Map()
/**
 * 场景
 */
let scene = null;

let model_group = null;
/**
 * 加载栏杆等障碍物；
 */
export const load_fused_track_traffic_sign = (vehicleData, threejs_globalScene) => {
    if (!localStorage.getItem('topicChannelChecks')?.includes('/trackList/fused_track/traffic_sign')) {
        clearGroupMap(model_map);
        return
    }
    if (!model_group) {
        model_group = new THREE.Group();
        model_group.position.set(0, 0, 1)
        threejs_globalScene.add(model_group);
    }
    if (vehicleData.trackList?.trafficSignList?.length > 0) {
        clearGroupMap(model_map);
        vehicleData.trackList?.trafficSignList.forEach(sign => {
            create_sign_model(sign, vehicleData.origin, model_group)
        })
    }else{
        
    }
}

export const clear_traffic_sign = () => {
    clearGroupMap(model_map);
}

/**
 * 清理模型
 * @param {*} map 
 */
const clearGroupMap = (map) => {
    for (let [key, model] of map) {
        model.visible = false;
        disposeO3D(model)
    }
    map.clear();
}

/**
 * 设置模型显示隐藏
 * @param {*} visible 
 */
function visibleElement(visible) {
    model_map.forEach(e => {
        e.visible = visible;
    })
}

async function create_sign_model(signInfo, origin, model_group) {
    let material = await getMaterial(signInfo.type);
    let z_tra = Math.min(Math.max(1, signInfo.location.z - origin.z), 10);
    const geometry = new THREE.BoxGeometry(1, 1, 1)
    const cube = new THREE.Mesh(geometry, material)
    cube.rotation.set(0, 0, Math.PI)
    cube.position.set(signInfo.location.x, signInfo.location.y, z_tra);
    if (!model_map.has(signInfo.id)) {
        model_group.add(cube)
        cube.signType = signInfo.type;
        model_map.set(signInfo.id, cube)
    }
}


let material_map = new Map();
// {
//     material,
//     promise,
// }
async function getMaterial(type) {
    if (material_map.has(type)) {
        let material_object = material_map.get(type);
        if (material_object.material) {
            return material_object.material;
        } else if (material_object.promise) {
            let material = await material_object.promise;
            material_object.material = material;
            return material;
        } else {
            material_map.delete(type);
        }
    } else {
        let img = getImg(type);
        let promise = getTrafficLightTexture(img)
        let material_object = {
            promise
        }
        material_map.set(type, material_object);
        material_object.material = await promise;
        return material_object.material
    }
}

function getImg(type) {
    let img = TS_UNKNOWN;
    switch (type) {
        case 1:
            img = TS_WARNING;
            break;
        case 2:
            img = TS_PROHIBITION;
            break;
        case 3:
            img = TS_DIRECTIVE;
            break;
        case 4:
            img = TS_WAY_GUIDE;
            break;
        case 5:
            img = TS_HIGHWAY_GUIDE;
            break;
        case 6:
            img = TS_AUXILIARY;
            break;
        case 7:
            img = TS_CONSTRUCTION_SAFETY;
            break;
        case 8:
            img = TS_TOURIST_AREA;
            break;       
        case 100:
            img = TS_PROHIBITION_STOP;
            break;
        case 101:
            img = TS_PROHIBITION_YIELD;
            break;
        case 102:
            img = TS_PROHIBITION_NO_ENTER;
            break;
        case 103:
            img = TS_PROHIBITION_NO_STOP;
            break;
        case 104:
            img = TS_PROHIBITION_SPEED_LIMIT;
            break;
        case 105:
            img = TS_PROHIBITION_HEIGHT_LIMIT;
            break;
        case 106:
            img = TS_PROHIBITION_WIDTH_LIMIT;
            break;
        case 107:
            img = TS_PROHIBITION_WEIGHT_LIMIT;
            break;
        case 108:
            img = TS_PROHIBITION_AXLE_WEIGHT_LIMIT;
            break;
        default:
            img = TS_UNKNOWN;
            break;
    }
    return img;
}
// enum TrafficSignType {
//     TS_UNKNOWN = 0;
//     TS_WARNING = 1;
//     TS_PROHIBITION = 2;
//     TS_DIRECTIVE = 3;
//     TS_WAY_GUIDE = 4;
//     TS_HIGHWAY_GUIDE = 5;
//     TS_AUXILIARY = 6;
//     TS_CONSTRUCTION_SAFETY = 7;
//     TS_TOURIST_AREA = 8;
// }

/**
 * 构造材质,根据不同类型获取材质。
 * @returns 
 */
const getTrafficLightTexture = (img) => {
    return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader()
        loader.load(
            // 资源URL
            img,
            // onLoad回调
            (texture) => {
                // in this example we create the material when the texture is loaded
                const material = new THREE.MeshBasicMaterial({
                    map: texture
                    // side: THREE.DoubleSide
                })
                resolve(material)
            },
            // 目前暂不支持onProgress的回调
            undefined,
            // onError回调
            function (err) {
                console.error(err)
                reject(err)
            }
        )
    })
}